import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const formatTime = (time) => {
  if (!time) return "--:--:--";
  // If time is already in HH:MM:SS or similar, just take first 8 chars
  return time.length >= 8 ? time.slice(0, 8) : time;
};

const MatchStats = ({ order, stats, isLoading = false, error = null }) => {
  const first = stats?.first_team || {};
  const second = stats?.second_team || {};
  let periods = stats?.periods || [];

  const firstTeamName = order?.home_team?.name || "first_team";
  const secondTeamName = order?.guest_team?.name || "second_team";

  return (
    <div className="tw-bg-gray-200 tw-rounded tw-p-4 tw-flex tw-gap-4 tw-relative">
      {/* Status indicators in top right corner */}
      <div className="tw-absolute tw-top-2 tw-right-2 tw-flex tw-gap-2 tw-items-center">
        {isLoading && (
          <FontAwesomeIcon
            icon={["fas", "spinner"]}
            spin
            className="tw-text-blue-600 tw-text-sm"
          />
        )}
        {error && !isLoading && (
          <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="stats-error-tooltip">{error}</Tooltip>}
          >
            <div className="tw-cursor-pointer">
              <FontAwesomeIcon
                icon={["fas", "exclamation-triangle"]}
                className="tw-text-yellow-600 tw-text-sm"
              />
            </div>
          </OverlayTrigger>
        )}
        {!error && !isLoading && (
          <FontAwesomeIcon
            icon={["fas", "check-circle"]}
            className="tw-text-green-600 tw-text-sm"
          />
        )}
      </div>

      {/* Periods vertical list inside the gray card */}
      {periods.length > 0 && (
        <div className="tw-max-h-24 tw-min-w-44 tw-overflow-y-auto">
          {periods.map((period, idx) => (
            <div
              key={idx}
              className="tw-flex tw-items-center tw-mb-1 tw-font-bold"
            >
              <span className="tw-mr-1">Period {idx + 1}</span>
              <span className="tw-font-normal tw-ml-1">
                {formatTime(period[0])} - {formatTime(period[1])}
              </span>
            </div>
          ))}
        </div>
      )}
      {/* Stats table */}
      <div>
        <div className="tw-grid tw-grid-cols-7 tw-gap-x-1 tw-text-center tw-font-semibold tw-mb-2">
          <div></div>
          <div>Goals</div>
          <div>Shots</div>
          <div>Passes</div>
          <div>Corners</div>
          <div>Fouls</div>
          <div>Free Kicks</div>
        </div>
        <div className="tw-grid tw-grid-cols-7 tw-gap-x-1 tw-text-center tw-items-center tw-mb-1">
          <div className="tw-font-bold tw-text-left">{firstTeamName}</div>
          <div>{first.goal ?? 0}</div>
          <div>{first.shot ?? 0}</div>
          <div>{first.pass ?? 0}</div>
          <div>{first.corner ?? 0}</div>
          <div>{first.foul ?? 0}</div>
          <div>{first.free_kick ?? 0}</div>
        </div>
        <div className="tw-grid tw-grid-cols-7 tw-gap-x-1 tw-text-center tw-items-center">
          <div className="tw-font-bold tw-text-left">{secondTeamName}</div>
          <div>{second.goal ?? 0}</div>
          <div>{second.shot ?? 0}</div>
          <div>{second.pass ?? 0}</div>
          <div>{second.corner ?? 0}</div>
          <div>{second.foul ?? 0}</div>
          <div>{second.free_kick ?? 0}</div>
        </div>
      </div>
    </div>
  );
};

export default MatchStats;
